import {Component, EventEmitter, forwardRef, Input, Optional, Output} from '@angular/core';
import {AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator} from "@angular/forms";
import {NbinputConfig, NbFieldType, SystemAttachment} from "./nbinput.entity";
import {NbinputUploadService} from "./nbinput-upload";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'nbinput-image',
  template: require('./nbinput-image.component.html'),
  styles: [require('./nbinput-image.component.scss')],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbinputImageComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => NbinputImageComponent),
      multi: true,
    }
  ]
})

export class NbinputImageComponent implements ControlValueAccessor, Validator {
  validate(c: AbstractControl): { [key: string]: any; } {
    this.data.forEach(e => {
      if (!e.completed || !e.success) {
        return {
          FilesOnUploading: {
            valid: false,
          },
        }
      }
    });
    return null;
  }
  registerOnValidatorChange?(fn: () => void): void {}
  writeValue(obj: SystemAttachment[]): void {
    if (obj && Array.isArray(obj)) {
      this.data = obj;
    }
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  registerOnChange(fn: any): void {
    if(fn) {this.onChangeCallback = fn;}
  }
  registerOnTouched(fn: any): void {if(fn) {this.onTouchedCallback = fn;}}
  onBlur() {this.onTouchedCallback();}

  @Input()
  public disabled;

  private onTouchedCallback = () => {};
  private onChangeCallback = (_) => {};

  @Input()
  config: NbinputConfig = new NbinputConfig();

  @Input()
  public readonly = false;

  @Input()
  public mime = '*';

  @Input()
  public type:NbFieldType = NbFieldType.Image;

  @Output()
  public fileChanged: EventEmitter<any> = new EventEmitter();
  submit() {
    // 只提交上传完成的文件
    const out = this.data.filter(e => e.completed && e.success);
    this.fileChanged.emit(out);
      this.onChangeCallback(out);
  }

  get value(): any {
    return this.data;
  };
  set value(v: any) {
    if (v !== this.data) {
      this.data = v;
      this.onChangeCallback(v);
    }
  }
  public _data: SystemAttachment[] = [];
  @Input()
  set data(val:SystemAttachment[]){
    if(val&&Array.isArray(val)){
      val.filter(v=>v.url&&v.url.length>0).forEach(v=>{
        v.completed = true;
        v.name = v.name || '未命名';
      });
      this._data = val;
    } else {
      this._data = [];
    }
  }
  get data(){
    return this._data;
  }
  external(img:string){
    return img.indexOf("http://")==0||img.indexOf("https://")==0;
  }

  onChange(event) {
    for (let i = 0; i < event.target.files.length; i++){
      // event.target.data[i].callback = this.submit;
      const a = new SystemAttachment(event.target.files[i]);
      a.completed = false;
      a.url = 'data:image/jpeg;base64,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';
      this.data.push(a);
      this.uploader.upload(event.target.files[i],this.config.uploadAPI)
        .subscribe(e=>{
          Object.assign(a,e);
          if (e.completed) {
            this.submit();
          }
        });
    }
    event.target.value = '';
    event.target.files = [];
  }

  delImg(img) {
    for (let i = 0; i < this.data.length; i++) {
      if (this.data[i] == img) {
        this.data.splice(i,1);
        this.submit();
        break;
      }
    }
  }

  constructor(
    private uploader: NbinputUploadService,
  ) {}
}
